import { LabelMedium, ParagraphMedium } from "baseui/typography";
import { FormattedMessage } from "react-intl";

export const LastXDaysLabel = (props: { days: number}) => <ParagraphMedium>
    <FormattedMessage id={'lastXdays'} defaultMessage={'last {days} days'} values={{ days: props.days}}></FormattedMessage>
</ParagraphMedium>
